import { render, staticRenderFns } from "./TotalLogChart.vue?vue&type=template&id=4c997d5c&scoped=true"
import script from "./TotalLogChart.vue?vue&type=script&lang=js"
export * from "./TotalLogChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c997d5c",
  null
  
)

export default component.exports